import * as React from "react";
import { useState } from "react";
import useDownloader from "react-use-downloader";
import { useQueryClient } from "@tanstack/react-query";
import { Stack, Typography } from "@mui/material";
import { useCallback } from "react";
import { useCardAttachment } from "../../../../../utils/reactQuery/cards";
import {
  downloadCardAttachment,
  deleteCardAttachment,
} from "../../../../../sevices/apiCards";
import "./showDetailAttachment.scss";
import SlideshowPopUp from "../attachedSlideShow/SlideshowPopUp";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { handleDownloadAttachment } from "../../../../../utils/downloadAttachments";
import useToastPromise from "../../../../../hooks/useToast";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import AttachmentList from "./AttchementList";
import useMutate from "../../../../../hooks/useMutate";
import { useParams, useSearchParams } from "react-router-dom";

export default React.memo(function AttachmentCard({ cardId }) {
  const [deleteAttachment, setDeleteAttachment] = useState(false);
  const [deleteAttachmentId, setDeleteAttachmentId] = useState(null);
  const [showAttachmentSlideShow, setShowAttachmentSlideShow] = useState(false);
  const [attachmentId, setAttachmentId] = useState(null);
  const queryClient = useQueryClient();
  const { download } = useDownloader();
  const isMobile = useResponsive("down", "md");
  const { showToastPromise } = useToastPromise();
  const { id: boardId } = useParams();
  const [searchParams] = useSearchParams();
  const {
    isLoading: isLoading,
    cardAttachment,
    isError: isError,
  } = useCardAttachment(cardId);

  const attachments = [];

  const { mutate: deleteCardAttachmentMutate, isPending } = useMutate(deleteCardAttachment, [],
    () => { },
    () => {
      queryClient.invalidateQueries({
        queryKey: [`cardAttachment`, cardId],
      });
      queryClient.invalidateQueries({
        queryKey: [`history`, String(cardId)],
      });
      queryClient.invalidateQueries({
        queryKey: [`feeds`, String(boardId),searchParams.get("milestone")],
      });
      handleClose();
    },
    () => {
      handleClose();
    },
  );
  const handleDelete = React.useCallback(() => {
    setDeleteAttachment(true);
  }, []);
  const handleClose = useCallback(() => {
    setDeleteAttachment(false);
  }, []);
  const callback = useCallback(() => {
    deleteCardAttachmentMutate(deleteAttachmentId);
  }, [deleteCardAttachmentMutate, deleteAttachmentId]);

  const handleSlideShowAttachment = React.useCallback((attachmentId) => {
    setAttachmentId(attachmentId);
    setShowAttachmentSlideShow(true);
  }, []);

  const handleView = useCallback((attachementId) => {
    const getResponse = downloadCardAttachment(attachementId);

    getResponse
      .then((res) => {
        handleDownloadAttachment(
          res.data.data.responseData.url,
          res.data.data.responseData.attachment_name,
          window.open,
          true
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleDownload = useCallback((attachmentId) => {
    const getResponse = downloadCardAttachment(attachmentId);

    getResponse
      .then((res) => {
        const responseData = res?.data?.data?.responseData;
        const filename =
          responseData?.attachment_name ?? responseData?.filename;
        const fileUrl = responseData?.url;

        if (filename && fileUrl) {
          const fileExtension = fileUrl.split(".").pop();

          const completeFilename = filename.endsWith(`.${fileExtension}`)
            ? filename
            : `${filename}.${fileExtension}`;

          handleDownloadAttachment(fileUrl, completeFilename, download);
        } else {
          console.error("Error: Filename or file URL is missing.");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [download]);


  return (
    <>
      {showAttachmentSlideShow && attachmentId && (
        <SlideshowPopUp
          attachmentId={attachmentId}
          slideImages={attachments}
          showAttachmentSlideShow={showAttachmentSlideShow}
          setShowAttachmentSlideShow={setShowAttachmentSlideShow}
        />
      )}

      {deleteAttachment && (
        <FormDialog
          open={deleteAttachment}
          handleClose={handleClose}
          handleSubmit={callback}
          loading={isPending}
          buttonTxt="Delete"
          title="Confirmation: Delete"
          alignActions={"center"}
          cancelBtn={true}
          fullWidth={true}>
          <Typography className="align_text_center mb-2">
            Are you sure to you want to delete this item? This action can not be
            undone
          </Typography>
        </FormDialog>
      )}

      <AttachmentList
        attachments={attachments}
        isMobile={isMobile}
        cardAttachment={cardAttachment}
        cardId={cardId}
        handleSlideShowAttachment={handleSlideShowAttachment}
        handleView={handleView}
        handleDownload={handleDownload}
        handleDelete={handleDelete}
        setDeleteAttachmentId={setDeleteAttachmentId}
      />
    </>
  );
})
